import { Box } from '@mui/material';

const DetailsRowVolet3 = () => {
  return (
    <Box className="flex flex-col w-[max-content]">
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Contribuer à la transition écologique de l’économie tunisienne à travers des modes de
          consommation et de production plus sobres, en phase avec l’économie verte
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold"></div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’Unité de Gestion par Objectifs pour la mise en œuvre de l’Accord de Paris
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Appuyer le développement d'un entrepreneuriat vert en Tunisie, intégrant les enjeux de
          genre et justice sociale
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.1.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’opérateurs économiques (TPMEs, startups, porteurs de projets) soutenus avec
          l’appui de l´UE, y compris financièrement
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec les partenaires soutenus (Gestionnaire Initiative Green Tech,
          structures intermédiaires, autres), incluant le cadre logique validé et signé Tableaux de
          suivi des entrepreneurs soutenus techniquement et financés mis à jour par les partenaires
          soutenus (avec les informations nécessaires pour la désagrégation) Rapports techniques et
          financiers trimestriels des partenaires soutenus Rapports de diagnostics (VV) Journaux des
          dépenses des partenaires soutenus (et d’EF pour VV) Contrats de financement avec les
          opérateurs financés par les partenaires soutenus et EF (VV) Rapports intermédiaires UE
          (EF) Rapports d'évaluation externe (2){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.1
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de PME adoptant des pratiques de production durable et ayant accès à des mécanismes
          de financement appropriés (Result indicator 1.2, NDICI 14, EURF 2.20, IPA PF 2.20)
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec les partenaires soutenus (Gestionnaire Initiative Green Tech,
          structures intermédiaires, autres), incluant le cadre logique validé et signé Tableaux de
          suivi des entrepreneurs soutenus techniquement et financés mis à jour par les partenaires
          soutenus (avec les informations nécessaires pour la désagrégation) Rapports techniques et
          financiers trimestriels des partenaires soutenus Rapports de diagnostics (VV) Journaux des
          dépenses des partenaires soutenus (et d’EF pour VV) Contrats de financement avec les
          opérateurs financés par les partenaires soutenus et EF (VV) Rapports intermédiaires UE
          (EF) Rapports d'évaluation externe (2)
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.1.3
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de mécanismes financiers verts développés/appuyés avec l’appui de l´UE
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec les partenaires soutenus (Gestionnaire Initiative Green Tech,
          structures intermédiaires, autres), incluant le cadre logique validé et signé Tableaux de
          suivi des entrepreneurs soutenus techniquement et financés mis à jour par les partenaires
          soutenus (avec les informations nécessaires pour la désagrégation) Rapports techniques et
          financiers trimestriels des partenaires soutenus Rapports de diagnostics (VV) Journaux des
          dépenses des partenaires soutenus (et d’EF pour VV) Contrats de financement avec les
          opérateurs financés par les partenaires soutenus et EF (VV) Rapports intermédiaires UE
          (EF) Rapports d'évaluation externe (2)
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Listes/Tableaux de suivi des entrepreneurs soutenus techniquement et financés mis à jour
          par les partenaires soutenus (avec les informations nécessaires pour la désagrégation)
          Rapports techniques et financiers trimestriels des partenaires soutenus Rapports
          intermédiaires UE (EF) Rapports d'évaluation externe (2)
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Listes/Tableaux de suivi des entrepreneurs soutenus techniquement et financés mis à jour
          par les partenaires soutenus (avec les informations nécessaires pour la désagrégation)
          Rapports techniques et financiers trimestriels des partenaires soutenus Rapports
          intermédiaires UE (EF) Rapports d'évaluation externe (2)
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Résultats d’enquêtes de perception post-soutien/ grilles d’appréciation administrées par
          EF à chaque opérateur économique soutenu Tableau de suivi des bénéficiaires des
          partenaires soutenus Rapports techniques trimestriels et financiers des partenaires
          soutenus (Gestionnaire Initiative Green Tech, structures intermédiaires, projets
          cofinancés) Rapports narratifs intermédiaires et de clôture UE (EF) Rapports évaluation
          externe intermédiaire et finale
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des éco-entreprises tunisiennes, y compris du secteur de la Green Tech, sont accompagnées
          dans leur création et/ou développement et croissance
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec le partenaire (dont budget contractuel) Rapports d'activité
          trimestriels et financiers du partenaire Rapports UE Rapports d'évaluation externe
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec les structures intermédiaires (dont budget contractuel)
          Rapports d'activité trimestriels et financiers des SI Tableau de suivi interne des SI
          subventionnées Rapports UE Rapports d'évaluation externe
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          P
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize font-bold">
          3.1.2
        </div>
        <div className="w-[220px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de structures intermédiaires soutenues pour l’accompagnement et le financement de
          l’entrepreneuriat vert
        </div>
        <div className="w-[280px] font-bold flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subvention avec les structures intermédiaires (dont budget contractuel)
          Rapports d'activité trimestriels et financiers des SI Tableau de suivi interne des SI
          subventionnées Rapports UE Rapports d'évaluation externe
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des entreprises tunisiennes sont soutenues dans leur transition écologique, notamment dans
          le secteur de l'artisanat
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de Green Assit avec les entreprises Contrats avec les bureaux d'études/experts
          indépendants Tableau de suivi des Green Vouchers Rapports des bureaux d'études
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats Green Boost les entreprises Contrats avec les fournissateurs Tableau de suivi des
          Green Vouchers Rapports d'activité des entreprises bénéficiaires
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Enquête de satisfaction post-diagnostic Enquête de satisfaction 6 mois après la mission de
          diagnostic (optionnel) Rapports de satisfaction GreenAssit Rapports UE
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des acteurs du financement de l'économie verte sont soutenus en Tunisie
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats/TdRs d'AT aux financeurs Rapports d'activité AT (produit par les consultants)
          Rapports UE
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Enquêtes de satisfaction après chaque mission d'AT aux financeurs Enquête de satisfaction
          6 mois après la mission d'AT (optionnel) Rapports d'activité AT (produit par les
          consultants) Rapports UE
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Contrats de subventions avec les projets de développement durable confinancés Rapports
          d'activité et financiers des projets cofinancés Tableau de suivi interne des projets
          cofinancés
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des actions de sensibilisation et de valorisation de l'entrepreneuriat vert et de la
          transition écologique sont mises en place{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          TDRs évènements Contrats d'achat évènements Rapports des bénéficaires Tableau de suivi
          évènements sponsorisés
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Listes de présence (dont extraction Excel) Rapports Evènements
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          TDRs outils Les livrables (outils){' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports Salons Internationaux Liste des startups/entreprises invitées Autres pièces
          justificatives (boarding pass, etc.).
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
    </Box>
  );
};

export default DetailsRowVolet3;
